(function($) { 
	$(document).ready(function(){ 
		$('.tabgroup > div').hide();
        $('.tabgroup > div:first-of-type').show();
        $('.tabs a').click(function(e){
          e.preventDefault();
            var $this = $(this),
                tabgroup = '#'+$this.parents('.tabs').data('tabgroup'),
                others = $this.closest('li').siblings().children('a'),
                target = $this.attr('href');
            others.removeClass('active');
            $this.addClass('active');
            $(tabgroup).children('div').hide();
            $(target).show();

        });
	});
    $(window).scroll(function(){
      $('body').toggleClass('scroll', $(this).scrollTop() > 100);
    });
})(jQuery);
